import { VisitInfo } from '../models/guestModel';
import { useNavigate } from 'react-router-dom';
import { LeadMarketplaceType } from '../../../components/VisitMarketplaceTypeBadge';
import AdminListGroup, {
  DisplayItem,
} from '../../../components/admin/AdminListGroup';
import RentSecondaryVisitBadge from '../../../components/badges/RentSecondaryVisitBadge';
import { VISIT_STATUS } from '../../../constants/visitsConstants';

interface Props {
  guestVisit: VisitInfo;
}

export default function GuestVisitDetailCard({ guestVisit }: Props) {
  const navigate = useNavigate();
  const toGuestVisitEdit = () =>
    navigate(`/guest-visits/${guestVisit.id}/edit`);

  const fieldMapper: DisplayItem[] = [
    {
      title: 'Estado',
      value: <RentSecondaryVisitBadge status={guestVisit.visit_status} />,
    },
    {
      title: 'Origen',
      value: `${guestVisit.visit_source} - ${guestVisit.visit_owner}`,
    },
    {
      title: 'Tipo',
      value: guestVisit.visit_type === 'presential' ? 'Presencial' : 'Virtual',
    },
    {
      title: 'Fecha y hora',
      value: `${guestVisit.visit_date} ${guestVisit.visit_time}`,
      href:
        guestVisit.visit_status === VISIT_STATUS.PENDING_APPROVAL ||
        (guestVisit.visit_status === VISIT_STATUS.SCHEDULED &&
          !guestVisit.proper_initial_selected_id)
          ? `/guest-visits/${guestVisit.id}/edit`
          : undefined,
    },
    {
      title: 'Negocio',
      value: `${
        guestVisit.marketplace_type === LeadMarketplaceType.ON_RENT
          ? 'Renta'
          : 'Venta'
      }`,
    },
  ];
  return <AdminListGroup title={'Visita'} items={fieldMapper} />;
}
